import * as React from 'react';
import {Button, Form, Input} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import ButtonBar from '../common/ButtonBar';
import locales from '../locales';
import FormItem from 'antd/lib/form/FormItem';
import * as formUtils from '../utils/form-utils';
import {isNotBlank} from '../utils/string-utils';
import {MaintenanceEntry, MaintenanceSheet} from '../api/dtos/dtos';

const InputGroup = Input.Group;

interface Props extends FormComponentProps {
  entries: MaintenanceEntry[];
  onFormSubmit: (maintenance: MaintenanceSheet) => void;
  onFormCancel: () => void;
}

interface State {
  entries: MaintenanceEntry[];
}

const emptyEntry = (): MaintenanceEntry => ({
  key: '',
  value: '',
});

class MaintenanceSheetForm extends React.Component<Props, State> {

  public state: State = {
    entries: this.props.entries && this.props.entries.length > 0 ? this.props.entries : [emptyEntry()],
  };

  public render(): React.ReactNode {
    const {entries} = this.state;
    return (
      <Form>
        <ButtonBar style={{marginBottom: 8}}>
          <Button size="small" type="primary" icon="plus" onClick={this.onAddButtonClick}>
            {locales.add}
          </Button>
        </ButtonBar>

        <div className="todo-form">
          {entries.map(this.renderRow)}
        </div>

        {this.props.children}

        <FormItem {...formUtils.tailFormItemLayout}>
          <Button type="primary" onClick={this.onFormSubmit}>
            {locales.save}
          </Button>
          <Button style={{marginLeft: 8}} onClick={this.props.onFormCancel}>
            {locales.cancel}
          </Button>
        </FormItem>
      </Form>
    );
  }

  private renderRow = (entry: MaintenanceEntry, idx: number): React.ReactNode => {
    const value = entry.value ? entry.value : '';
    return (
      <InputGroup
        key={`row-${idx}`}
        compact={true}
        style={{display: 'flex', marginBottom: 16}}
      >
        <Input
          style={{flex: 1}}
          value={entry.key}
          placeholder={locales.appellation}
          onChange={this.onKeyChange(idx)}
        />
        <Input
          style={{flex: 1.5}}
          value={value}
          placeholder={locales.content}
          onChange={this.onValueChange(idx)}
        />
        <Button
          icon="delete"
          style={{width: 36}}
          title={locales.delete}
          onClick={this.onDeleteButtonClick(idx)}
        />
      </InputGroup>
    );
  };

  private onKeyChange = (idx: number) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.replaceEntryAt(idx, {
      key: evt.target.value,
      value: this.state.entries[idx].value,
    });
  };

  private onValueChange = (idx: number) => (evt: React.ChangeEvent<HTMLInputElement>) => {
    this.replaceEntryAt(idx, {
      key: this.state.entries[idx].key,
      value: evt.target.value,
    });
  };

  private replaceEntryAt(idx: number, entry: MaintenanceEntry) {
    const entries = [...this.state.entries];
    entries.splice(idx, 1, entry);
    this.setState({entries,});
  }

  private onDeleteButtonClick = (idx: number) => () => {
    const entries = [...this.state.entries];
    entries.splice(idx, 1);

    if (entries.length === 0) {
      entries.push(emptyEntry());
    }

    this.setState({entries,});
  };

  private onAddButtonClick = () => {
    const {entries} = this.state;
    this.setState({
      entries: [emptyEntry(), ...entries],
    });
  };

  private onFormSubmit = () => {
    this.props.onFormSubmit({
      entries: this.state.entries.filter(entry => isNotBlank(entry.key))
    });
  };
}

export default Form.create<Props>()(MaintenanceSheetForm);


// WEBPACK FOOTER //
// ./src/item-details/MaintenanceSheetForm.tsx